<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->

<div class="row no-pad-lr no-mar-lr">
  <div class="col-md-12 pad-tb-20">
    <!--Show Supplier Coed Filtering for SM, SM-VS, Logistics Users -->
    <div class="row" *ngIf="userRoleId != 1 && userRoleId != 4">
      <div class="col-md-5 text-right pad-top-10">
        {{'Select Supplier Code' | translate}} &nbsp;&nbsp;&nbsp;
      </div>
      <div class="col-md-7 input-group">

        <ng-multiselect-dropdown #suppliercode="ngModel" name="suppliercode" [(ngModel)]="supPoint"
        [settings]="dropdownSettings2" [data]="suppCodeList" >
        </ng-multiselect-dropdown>
        <span class="input-group-btn">
          <button class="btn btn-light" type="button" (click)="getAllCountPartWise()" [disabled]="disableSuppCodeSearch">
            {{'Search' | translate}}
          </button>
        </span>
      </div>
    </div>

    <!--Show Delivery Point Filtering only for Operation Users -->
    <div class="row delPntFilter" *ngIf="userRoleId == 4">
      <div class="col-md-5 text-right pad-top-10">
        {{'Select the Next Process' | translate}} &nbsp;&nbsp;&nbsp;
      </div>
      <div class="col-md-7 input-group">
        <ng-multiselect-dropdown *ngIf="lineNoList"  [(ngModel)]="lineNoFilter" [settings]="dropdownSettings" [data]="lineNoList">
        </ng-multiselect-dropdown>
        <span class="input-group-btn" *ngIf="lineNoList">
          <button class="btn btn-light" type="button" (click)="getAllCountPartWise()" [disabled]="disableNextProcessSearch">
            {{'Search' | translate}}
          </button>
        </span>
      </div>
    </div>
  </div>

</div>
<section class="notification_container">
  <div class="dta_title mar-tb-20 pad-lr-15">{{'NOTIFICATIONS' | translate}}</div>
  <div class="container-fluid">
    <div class="row no-pad mar-btm-10">
      <div class="col-md-2 mar-btm-10 mar-rgt-30" (click)="openModal(partTable, 'new', 1)">
        <button class="notification_cards">
          <div class="card_noti_count text-right">
            {{notificationCount.NewPart}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/new-parts-dashboard-Icon.png">
          </div>
          <div class="card_title text-center">
            {{'NEWPARTS' | translate}}
          </div>
        </button>
      </div>
      <div class="col-md-2 mar-rgt-30" (click)="openModal(partTable, 'rejected', 1)">
        <button class="notification_cards">
          <div class="card_noti_count text-right">
            {{notificationCount.Rejected}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/part-status-dashboard-icon.png">
          </div>
          <div class="card_title text-center">
            {{'PARTSREJECTED' | translate}}
          </div>
        </button>
      </div>

      <div class="col-md-2 mar-rgt-30" id="awaiting" (click)="openModal(partTable, 'underReview', 1)">
        <button class="notification_cards">
          <div class="card_noti_count text-right">
            {{notificationCount.Awating}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/part-status-dashboard-icon.png">
          </div>
          <div class="card_title text-center">
            {{'AWAITINGAPPROVAL' | translate}}
          </div>
        </button>
      </div>
    </div>
    <div>
      <div class="card_approve_count">
        {{'PARTSAPPROVED' | translate}} - {{notificationCount.Approved}}
      </div>
    </div>
  </div>

  <div class="desc_title container-fluid ">{{'BodyText' | translate}}</div>
  <hr />
</section>

<ng-template #partTable let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{'PARTSTATUS' | translate}} - {{partStatus}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="partStatusTbl">
      <div class="row">
        <div class="col-md-6 mx-auto">
          <div class="input-group custom-search-form" >
            <input  placeholder="{{'SEARCHBY' | translate}}" 
              class="form-control" [(ngModel)]="searchText" />
            <span class="input-group-btn">
              <button class="btn btn-light" type="button" (click)="onChangeTable(config)">
                {{'Search' | translate}}
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="col-md-12">
            <!-- <pagination *ngIf="config.paging" class="pagination-sm pull-right" [(ngModel)]="page" [totalItems]="length"
              [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)"
              (numPages)="numPages = $event">
            </pagination> -->
          </div>
          <!-- <ng-table [config]="config" (tableChanged)="onChangeTable(config)" (cellClicked)="onCellClick($event)" [rows]="rows"
            [columns]="columns">
          </ng-table> -->

          <pagination *ngIf="config.paging"  [(ngModel)]="page" [totalItems]="length"
              [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)"
              (numPages)="numPages = $event">
            </pagination>
          

             <div class="example-container mat-elevation-z8">
          
            <mat-table [dataSource]="dataSource" >
          
              
              <ng-container matColumnDef="partNumber">
                <mat-header-cell *matHeaderCellDef > Part Number </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.partNumber}} </mat-cell>
              </ng-container>
          
              <ng-container matColumnDef="supplierCode">
                <mat-header-cell *matHeaderCellDef > Supplier Code </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.supplierCode}} </mat-cell>
              </ng-container>
          
           
              <ng-container matColumnDef="partName">
                <mat-header-cell *matHeaderCellDef > Part Name </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.partName}} </mat-cell>
              </ng-container>
          
              
              <ng-container matColumnDef="assignedDate">
                <mat-header-cell *matHeaderCellDef > Assigned Date </mat-header-cell>
                <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.assignedDate}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="lastDate">
                <mat-header-cell *matHeaderCellDef > Last Date </mat-header-cell>
                <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.lastdate}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="dueDate">
                <mat-header-cell *matHeaderCellDef > Due Date </mat-header-cell>
                <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.duedate}} </mat-cell>
              </ng-container>
          
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;">
              </mat-row>
            </mat-table>
           
        </div>
          
      </div>
    </div>
  </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'Close' | translate}}</button>
  </div>
</ng-template>